import Column from "theme/layouts/Column";
import Meta from "core-web/components/Meta";
import PaginationButtons from "theme/components/ListProducts/PaginationButtons";
import PropTypes from "prop-types";
import TextStyles from "theme/components/text/TextStyles";
import colors from "theme/config/colors";
import styled from "theme/libs/styled";
import { useTranslation } from "react-i18next";

const StyledColumn = styled(Column)`
    text-align: center;
    align-items: center;
    max-width: max(624px, 100%);
`;

const Pagination = ({ page, offset, pageCount, pageSize, hitsCount, hits, handleClick, suffix }) => {
    const { t } = useTranslation();
    const hitsSeen = page > 0 ? page * pageSize + hits : hitsCount > hits ? pageSize : hits;
    const seen = offset ? offset + hits : hitsCount < hits ? hitsCount : hitsSeen;

    return (
        <>
            <Meta layout="pagination" current={page} total={pageCount} hitsCount={hitsCount} seen={seen} />
            <StyledColumn gap={["16px", null, null, null, "24px"]} m={["64px 0", null, null, null, "88px 0 104px"]}>
                <PaginationButtons current={page} total={pageCount} handleClick={handleClick} />
                <TextStyles textStyles="Myriad Pro/14-100" color={colors.black_70}>
                    {t("pagination.number_of_hits_showing", { seen, hitsCount })}
                    {suffix && ` ${suffix}`.toLowerCase()}
                </TextStyles>
            </StyledColumn>
        </>
    );
};

Pagination.propTypes = {
    handleClick: PropTypes.func,
    hits: PropTypes.number.isRequired,
    hitsCount: PropTypes.number.isRequired,
    offset: PropTypes.number,
    page: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    suffix: PropTypes.string,
};

Pagination.defaultProps = {
    handleClick: () => null,
    offset: null,
    suffix: null,
};

export default Pagination;
